import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './contact.css';
import SITELOGO from '../images/SITELOGO.jpg';
import LICARULPROFILE from '../images/LICARULPROFILE.jpeg'
import Topbar from './Topbar';
export default function Contact() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
    <div><Topbar/></div>
      <div><Navbar /></div>
      <div className="container">

        <section className="header-section">
        <center>
    <img src={SITELOGO} alt='appollo agency' title='appollo agency' width={300} height={250} className='img-fluid'/>
    </center>
          
          <h1>Contact Us</h1>
          <p>We're Here to Help!</p>
        </section>

        <section className="contact-info-section">
          <h2>Get in Touch with Us</h2>
          <p className="contact-info">
            <i className="fas fa-map-marker-alt"></i>
            <h1 style={{ color: "#ff4500", fontSize: "20px", fontFamily: "Arial Black, sans-serif" }}>
    Appollo Agency
</h1>

            <h1>Head Office</h1>
           13.A, Sudhanandha Bharathi St.,<br />
            East Tambaram, Chennai-600059.<br />
          
          </p>
          <p className="contact-info">
            <i className="fas fa-map-marker-alt"></i>
            <h1>Branch Office</h1>
           306/16,Mudichur Main Raod,<br />
            Mannivakam, Chennai-600049.<br />
          
          </p>
          <p className="contact-info">
            <i className="fas fa-phone"></i>
            Phone: +919884226561
          </p>
          {/* <p className="contact-info">
            <i className="fas fa-envelope"></i>
            Email: contact@harihomecare.com
          </p> */}
          <p className="contact-info">
            Our team is available Monday to Saturday, from 9 AM to  7 PM. Don't hesitate to reach out with any questions or to schedule a service!
          </p>
        </section>

        <section className="map-section">
          <h2>Our Location</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d312045.38506847995!2d80.17555565053568!3d13.059150661682886!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5260f3a9190b73%3A0x9f1c4a06c6e0208a!2sNo.8%2C%20Anna%20Nagar%208th%20Street%2C%20Anna%20Nagar%2C%20Chennai%2C%20Tamil%20Nadu%20600024!5e0!3m2!1sen!2sin!4v1633359425112!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            title="Our Location"
          ></iframe>
        </section>
      </div>
      <div><Footer /></div>
    </>
  );
}
